import type { ValueOf } from '../util/typeUtils';

export const TEAM_RESOLVERS = {
    get: 'get',
    getByLeaderId: 'getByLeaderId',
    listByCategory: 'listByCategory',
    listByCorporation: 'listByCorporation',
    listByDivision: 'listByDivision',
} as const;

export type TEAM_RESOLVER = ValueOf<typeof TEAM_RESOLVERS>;
